import React from "react";
import { Modal, Button, Glyphicon, Alert } from "react-bootstrap";
import DatePicker from "react-datepicker";
import formWithMessages from "sc/ui/components/hoc/formWithMessages";
import moment from "moment";

export const ERROR_EMPTY_NAME = "empty_name";

class CalendarTrigger extends React.Component {
  render() {
    const split = this.props.value.split(" ");
    const date = split[0];
    const time = split[1] + " " + split[2];
    return (
      <Button
        onClick={this.props.onClick}
        style={{
          padding: "2px",
          fontSize: "xx-small",
        }}
      >
        <Glyphicon
          glyph="calendar"
          style={{
            fontSize: "initial",
          }}
        />
        <br />
        {date}
        <br />
        {time}
      </Button>
    );
  }
}

export default formWithMessages(
  class extends React.Component {
    constructor(props) {
      super(props);
      if (props.shift !== undefined) {
        this.state = {
          start: moment(props.shift.start),
          end: moment(props.shift.end),
          priority: props.shift.priority,
          deleteConfirmationPopup: false,
          saveShiftErrorModal: false,
        };
      }
    }

    showPopup = () => this.setState({ deleteConfirmationPopup: true });
    hidePopup = () => this.setState({ deleteConfirmationPopup: false });
    hideShiftErrorModal = () => this.setState({ saveShiftErrorModal: false });
    handleChangePriority = event =>
      this.setState({ priority: event.target.value });
    deleteShift = () => {
      this.hidePopup();
      this.props.onDelete();
    };

    changeStart = start => this.setState({ start });
    changeEnd = end => this.setState({ end });
    save = event => {
      if (this.state.start >= this.state.end) {
        this.setState({ saveShiftErrorModal: true });
      } else {
        this.props.onSave({
          ...this.props.shift,
          start: this.state.start.toDate(),
          end: this.state.end.toDate(),
          priority: this.state.priority,
        });
      }
    };

    render() {
      const { shift } = this.props;
      if (shift === undefined) {
        const alertContents =
          "Select a shift by clicking on it to delete it or change its properties.";
        return (
          <Alert key="alert" bsStyle="info">
            <strong>{alertContents}</strong>
          </Alert>
        );
      }
      return [
        <div key="engineer" className="rbc-event rbc-selected">
          <div className="rbc-event-content">
            <div>{`${shift.engineer.firstName} ${
              shift.engineer.lastName
            }`}</div>
          </div>
        </div>,
        <br key="spacing-0" />,
        <div key="interval">
          <div style={{ display: "inline-block" }}>
            <DatePicker
              inlineBlock
              customInput={<CalendarTrigger />}
              selectsStart
              selected={this.state.start}
              onChange={this.changeStart}
              startDate={this.state.start}
              endDate={this.state.end}
              showTimeSelect
              timeIntervals={15}
              dateFormat="YYYY-MM-DD hh-mm A"
              withPortal
            />
          </div>
          <div
            style={{
              display: "inline-block",
              width: "calc(100% - 106px)",
            }}
          />
          <div style={{ display: "inline-block" }}>
            <DatePicker
              customInput={<CalendarTrigger />}
              selectsEnd
              selected={this.state.end}
              onChange={this.changeEnd}
              startDate={this.state.start}
              endDate={this.state.end}
              showTimeSelect
              timeIntervals={15}
              dateFormat="YYYY-MM-DD hh-mm A"
              withPortal
            />
          </div>
        </div>,
        <br key="spacing-1" />,
        <div key="priority-container">
          <label key="priority-label">Priority:</label>
          <select
            id="priority"
            key="priority"
            value={this.state.priority}
            onChange={this.handleChangePriority}
            className="pull-right"
          >
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
          </select>
        </div>,
        <br key="spacing-2" />,
        <div key="save">
          <Button
            id="reschedule"
            bsStyle="success"
            onClick={this.save}
            style={{ width: "100%" }}
          >
            Save
          </Button>
        </div>,
        <br key="spacing-3" />,
        <div key="delete">
          <Button
            id="attempt-delete"
            bsStyle="link"
            style={{ width: "100%" }}
            onClick={this.showPopup}
          >
            Delete Shift?
          </Button>
        </div>,
        <Modal
          key="delete-confirmation"
          show={this.state.deleteConfirmationPopup}
          onHide={this.hidePopup}
        >
          <Modal.Header closeButton>
            <Modal.Title>{shift.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>Are you sure you want to delete this shift?</div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              id="delete"
              className="btn btn-danger"
              onClick={this.deleteShift}
            >
              Delete Shift
            </Button>
            <Button
              id="close"
              className="btn btn-primary "
              onClick={this.hidePopup}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>,
        <Modal
          key="save-shift-error-modal"
          id="save-shift-error-modal"
          show={this.state.saveShiftErrorModal}
          onHide={this.hideShiftErrorModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              The entered date and time values are not valid.
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              The end time of the shift must be greater than start time of the
              shift.
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              id="close-shift-modal"
              className="btn btn-primary"
              onClick={this.hideShiftErrorModal}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>,
      ];
    }
  },
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/components/forms/Shift.js